var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSimple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5257 1.71084C12.4203 1.51911 12.2188 1.39999 12 1.39999C11.7812 1.39999 11.5797 1.51911 11.4743 1.71084L0.474272 21.7108C0.37204 21.8967 0.375559 22.1228 0.483528 22.3054C0.591497 22.488 0.787865 22.6 1 22.6H23C23.2121 22.6 23.4085 22.488 23.5165 22.3054C23.6244 22.1228 23.628 21.8967 23.5257 21.7108L12.5257 1.71084ZM2.01476 21.4L12 3.24502L21.9852 21.4H2.01476ZM12.5453 9.49999V16.5H11.4555V9.49999H12.5453ZM11.5141 18.8183C11.4047 18.6973 11.35 18.5469 11.35 18.3672C11.35 18.1797 11.4047 18.0234 11.5141 17.8984C11.6273 17.7734 11.7953 17.7109 12.018 17.7109C12.2406 17.7109 12.4086 17.7734 12.5219 17.8984C12.6391 18.0234 12.6977 18.1797 12.6977 18.3672C12.6977 18.5469 12.6391 18.6973 12.5219 18.8183C12.4086 18.9394 12.2406 19 12.018 19C11.7953 19 11.6273 18.9394 11.5141 18.8183Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSimple);
export default __webpack_public_path__ + "static/media/WarningSimple.b82fbbc420bb20596bcef17fcc14c886.svg";
export { ForwardRef as ReactComponent };